
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.b2055022488 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a818927848 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b66301716 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a968834675 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.b1711183716 = pluralGeneratorFn(function(n
) {
  return (n == 1) ? 'one' : 'other';
});
Globalize.b2110274922 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1908518796 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a63622391 = messageFormatterFn((function(  ) {
  return function(d) { return "Correo electrónico"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b580798206 = messageFormatterFn((function(  ) {
  return function(d) { return "Contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b946531423 = messageFormatterFn((function(  ) {
  return function(d) { return "Esto es un dispositivo de uso público o compartido"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b814839846 = messageFormatterFn((function(  ) {
  return function(d) { return "¿No estás en tu dispositivo? Al activar esta casilla, tu sesión durará menos tiempo abierta aquí."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1795172107 = messageFormatterFn((function(  ) {
  return function(d) { return "Mantener la sesión abierta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b697197737 = messageFormatterFn((function(  ) {
  return function(d) { return "Si seleccionas esta casilla, se mantendrá abierta tu sesión en este dispositivo hasta que cierres la sesión. No selecciones esta casilla si compartes tu dispositivo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1373491169 = messageFormatterFn((function(  ) {
  return function(d) { return "¿Olvidaste tu contraseña?"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1219256078 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1067229343 = messageFormatterFn((function(  ) {
  return function(d) { return "Cancelar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b356183032 = messageFormatterFn((function(  ) {
  return function(d) { return "Volver"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a611168778 = messageFormatterFn((function(  ) {
  return function(d) { return "Actualizar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a837480015 = messageFormatterFn((function(  ) {
  return function(d) { return "Al registrarme, acepto los <a href=" + d["1"] + " " + d["3"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["4"] + ">Aviso de privacidad</a> de " + d["0"] + "."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1134437773 = messageFormatterFn((function(  ) {
  return function(d) { return "Al registrarme, acepto los <a href=" + d["1"] + " " + d["5"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["6"] + ">Aviso de privacidad</a> de " + d["0"] + ", además de los <a href=" + d["3"] + " " + d["7"] + ">Términos y condiciones de " + d["4"] + "</a>."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1153461765 = messageFormatterFn((function(  ) {
  return function(d) { return "Al iniciar sesión, me registro en " + d["4"] + ". Acepto los <a href=" + d["1"] + " " + d["5"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["6"] + ">Aviso de privacidad</a> de " + d["0"] + ", además de los <a href=" + d["3"] + " " + d["7"] + ">Términos y condiciones de " + d["4"] + "</a>."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b352435878 = messageFormatterFn((function(  ) {
  return function(d) { return "Tu cuenta se puso en pausa debido a una verificación de seguridad de rutina. Tus datos están a salvo, aunque debes restablecer la contraseña. Para hacerlo, usa el enlace \"¿Olvidaste tu contraseña?\" que aparece abajo e inicia sesión."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2033757648 = messageFormatterFn((function(  ) {
  return function(d) { return "El correo electrónico y la contraseña no coinciden. Inténtalo de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b150114805 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocurrió un error."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b939271087 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocurrió un error. Espera un momento e inténtalo de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a334991471 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa tu dirección de correo electrónico."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1822695424 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa una dirección de correo electrónico válida."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1825784186 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa la contraseña."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1724349988 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificando datos de inicio de sesión"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a71637921 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocultar contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a385980060 = messageFormatterFn((function(  ) {
  return function(d) { return "Mostrar contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2080532190 = messageFormatterFn((function(  ) {
  return function(d) { return "¿No tienes una cuenta? <span><a id=\"createAcctRedirectLink\" href=" + d["0"] + ">Crear una</a></span>"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1167755367 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2104465374 = messageFormatterFn((function(  ) {
  return function(d) { return "Ya no es posible iniciar sesión a través de " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1028195962 = messageFormatterFn((function(  ) {
  return function(d) { return "Puedes restablecer tu contraseña y usar la misma dirección de correo electrónico para acceder a tu cuenta de " + d["0"] + ". Esto no afectará a tu cuenta de " + d["1"] + "."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b922664140 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa el botón a continuación para restablecer la contraseña. La próxima vez, usa tu correo electrónico y la nueva contraseña para iniciar sesión directamente en " + d["0"] + "."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b586281939 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sesión (SSO)"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a422258869 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión con una autenticación única"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1333708321 = messageFormatterFn((function(  ) {
  return function(d) { return "O usa tu cuenta de " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a214400018 = messageFormatterFn((function(  ) {
  return function(d) { return "Acumula puntos para viajar gratis, ahorra con los Precios para socios y accede fácilmente a tus itinerarios."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b544956628 = messageFormatterFn((function(  ) {
  return function(d) { return "Acumula " + d["0"] + " puntos de Expedia Rewards al finalizar este viaje."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b950742345 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicio de sesión en " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1762671247 = messageFormatterFn((function(  ) {
  return function(d) { return "Abrir en una nueva pestaña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a385478317 = messageFormatterFn((function(  ) {
  return function(d) { return "Términos y condiciones (" + d["0"] + ")"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a223485841 = messageFormatterFn((function(  ) {
  return function(d) { return "Aviso de privacidad (" + d["0"] + ")"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1239579054 = messageFormatterFn((function(  ) {
  return function(d) { return "Términos y condiciones del programa de lealtad One Key (" + d["0"] + ") "; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b363397497 = messageFormatterFn((function(  ) {
  return function(d) { return "Olvidé mi contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2131676048 = messageFormatterFn((function(  ) {
  return function(d) { return "Restablece tu contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b509576170 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1989225366 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar enlace"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2031212429 = messageFormatterFn((function(  ) {
  return function(d) { return "¡Revisa tu bandeja de entrada!"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1388759499 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviamos un correo a " + d["0"] + " con un enlace para restablecer tu contraseña."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1388758538 = messageFormatterFn((function(  ) {
  return function(d) { return "Es posible que te tome unos minutos recibir el correo. Si no recibes el mensaje después de 10 minutos, revisa tu papelera o carpeta de spam."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a344676960 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar vínculo"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a264635096 = messageFormatterFn((function(  ) {
  return function(d) { return "Se envió un vínculo nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a991776245 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificando cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1604371893 = messageFormatterFn((function(  ) {
  return function(d) { return "Establece una contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1940950434 = messageFormatterFn((function(  ) {
  return function(d) { return "¡Nos alegra que estés de regreso!"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b174610236 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una contraseña única para continuar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a721155377 = messageFormatterFn((function(  ) {
  return function(d) { return "¡Listo!"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a260885036 = messageFormatterFn((function(  ) {
  return function(d) { return "Desde ahora usa esta nueva contraseña para iniciar sesión."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1701025177 = messageFormatterFn((function(  ) {
  return function(d) { return "Restablecer contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b161404220 = messageFormatterFn((function(  ) {
  return function(d) { return "Esta solicitud ya venció. Si aún necesitas cambiar tu contraseña, haz clic abajo y te enviaremos un correo nuevo para restablecerla."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b788639532 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar vínculo"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a788975231 = messageFormatterFn((function(  ) {
  return function(d) { return "Guardando tu contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b393048723 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b529296545 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a800850092 = messageFormatterFn((function(  ) {
  return function(d) { return "Correo electrónico"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1476701404 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa tu dirección de correo electrónico."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a252703221 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa una dirección de correo electrónico válida."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b715834421 = messageFormatterFn((function(  ) {
  return function(d) { return "Nombre"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1607036349 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa tu nombre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1151475379 = messageFormatterFn((function(  ) {
  return function(d) { return "Apellido"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1786767045 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa tu apellido."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1907806412 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa un nombre usando letras únicamente"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2001857837 = messageFormatterFn((function(  ) {
  return function(d) { return "Contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b936384587 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa la contraseña."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1624083268 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa una contraseña válida."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a354672508 = messageFormatterFn((function(  ) {
  return function(d) { return "Incluye de 9 a 64 caracteres"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a354673469 = messageFormatterFn((function(  ) {
  return function(d) { return "Combina letras y números"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a354674430 = messageFormatterFn((function(  ) {
  return function(d) { return "Un carácter especial (ej., ~ " + "#" + " @ $ % & ! * _ ? ^ -)"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a354675391 = messageFormatterFn((function(  ) {
  return function(d) { return "La contraseña no puede tener espacios"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b446066054 = messageFormatterFn((function(  ) {
  return function(d) { return "Tu contraseña debe tener entre 8 y 64 caracteres"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1780845607 = messageFormatterFn((function(  ) {
  return function(d) { return "La contraseña no puede ser tu dirección de correo electrónico."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a602996260 = messageFormatterFn((function(  ) {
  return function(d) { return "La contraseña no puede tener espacios."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b142757540 = messageFormatterFn((function(  ) {
  return function(d) { return "Al crear una cuenta, acepto los <a href=" + d["1"] + " " + d["3"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["4"] + ">Aviso de privacidad</a> de " + d["0"] + "."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2095527046 = messageFormatterFn((function(  ) {
  return function(d) { return "Al crear una cuenta, acepto los <a href=" + d["1"] + " " + d["5"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["6"] + ">Aviso de privacidad</a> de " + d["0"] + ", además de los <a href=" + d["3"] + " " + d["7"] + ">Términos y condiciones de " + d["4"] + "</a>."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1347947481 = messageFormatterFn((function(  ) {
  return function(d) { return "Quiero recibir correos electrónicos de " + d["0"] + " con ofertas de viajes, promociones especiales y más información."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b416684632 = messageFormatterFn((function(  ) {
  return function(d) { return "Quiero recibir correos electrónicos de " + d["0"] + " con ofertas de viajes, promociones especiales y más información. Puedes dejar de recibir estos correos en cualquier momento."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a714758826 = messageFormatterFn((function(  ) {
  return function(d) { return "Quiero recibir correos electrónicos de " + d["0"] + " con ideas de vacaciones, promociones especiales y más información."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a944466949 = messageFormatterFn((function(  ) {
  return function(d) { return "Quiero recibir correos electrónicos de " + d["0"] + " con ideas de vacaciones, promociones especiales y más información. Puedes dejar de recibir estos correos en cualquier momento."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b493055175 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a989568378 = messageFormatterFn((function(  ) {
  return function(d) { return "¿Ya tienes una cuenta? <span><a id=\"signinRedirectLink\" href=" + d["0"] + ">Iniciar sesión</a></span>"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a880837571 = messageFormatterFn((function(  ) {
  return function(d) { return "Hola, " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a453833123 = messageFormatterFn((function(  ) {
  return function(d) { return "Con tu nueva cuenta de " + d["0"] + ", el mundo está a tu alcance."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1968833068 = messageFormatterFn((function(  ) {
  return function(d) { return "Continuar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1536959579 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa una contraseña más segura para continuar."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1250555498 = messageFormatterFn((function(  ) {
  return function(d) { return "Debe tener al menos 8 caracteres."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b683654002 = messageFormatterFn((function(  ) {
  return function(d) { return "Seguridad de la contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1266366452 = messageFormatterFn((function(  ) {
  return function(d) { return "Débil"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b253540589 = messageFormatterFn((function(  ) {
  return function(d) { return "Fuerte"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a502561257 = messageFormatterFn((function(  ) {
  return function(d) { return "Muy fuerte"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1112565660 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita hacer reemplazos obvios de letras, como \"a\" por \"@\"."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1915155972 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita incluir palabras de uso común escritas al revés."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1664171380 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa mayúsculas en algunas letras, no en todas."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1492545429 = messageFormatterFn((function(  ) {
  return function(d) { return "No uses mayúscula solo en la primera letra."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1838213799 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita usar fechas y años relacionados contigo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2076331933 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita incluir años recientes."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b901688392 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita usar años relacionados contigo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b141974091 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita usar secuencias de caracteres comunes."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1080334513 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita repetir palabras y caracteres."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b197220493 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa una mayor variedad de letras y escribe algunas partes al revés."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1082673112 = messageFormatterFn((function(  ) {
  return function(d) { return "Agrega palabras de uso menos común."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1287617604 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa varias palabras, tan solo evita frases comunes."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a589225639 = messageFormatterFn((function(  ) {
  return function(d) { return "Puedes crear contraseñas seguras sin usar símbolos, números o mayúsculas."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b128363794 = messageFormatterFn((function(  ) {
  return function(d) { return "Esta dirección ya está asociada a una cuenta de  " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2095788448 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviamos un enlace a tu correo electrónico para que termines de crear tu cuenta."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1742447823 = messageFormatterFn((function(  ) {
  return function(d) { return "Proceso de registro en curso"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1550391877 = messageFormatterFn((function(  ) {
  return function(d) { return "El nombre debe tener un mínimo de 2 caracteres"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1178164781 = messageFormatterFn((function(  ) {
  return function(d) { return "El apellido debe tener un mínimo de 2 caracteres"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b302342039 = messageFormatterFn((function(  ) {
  return function(d) { return "El nombre puede tener un máximo de 100 caracteres"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a69885057 = messageFormatterFn((function(  ) {
  return function(d) { return "El apellido puede tener un máximo de 100 caracteres"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1928786212 = messageFormatterFn((function(  ) {
  return function(d) { return "El nombre no puede tener caracteres especiales"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1138227396 = messageFormatterFn((function(  ) {
  return function(d) { return "El apellido no puede tener caracteres especiales"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1490318978 = messageFormatterFn((function(  ) {
  return function(d) { return "Acepto los siguientes términos:"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1036432398 = messageFormatterFn((function(  ) {
  return function(d) { return "Confirmo que tengo 18 años o más, y que leí y acepto los <a href=" + d["0"] + " " + d["1"] + ">Términos de uso</a> y los <a href=" + d["2"] + " " + d["3"] + ">Términos y condiciones de " + d["4"] + "</a> (obligatorio)."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b333236748 = messageFormatterFn((function(  ) {
  return function(d) { return "Autorizo la recopilación y uso de mis datos personales según lo descrito en el <a href=" + d["0"] + " " + d["1"] + ">aviso de privacidad</a> (obligatorio)."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1685904039 = messageFormatterFn((function(  ) {
  return function(d) { return "Autorizo que mis datos personales se compartan con terceros, ya sea en Corea del Sur o en el extranjero, según lo descrito en el <a href=" + d["0"] + " " + d["1"] + ">aviso de privacidad</a> (obligatorio)."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a74536086 = messageFormatterFn((function(  ) {
  return function(d) { return "Para continuar, debes aceptar los términos."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2093861998 = messageFormatterFn((function(  ) {
  return function(d) { return "Para continuar, acepta los términos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b408416754 = messageFormatterFn((function(  ) {
  return function(d) { return "Selecciona la casilla para continuar."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a290125831 = messageFormatterFn((function(  ) {
  return function(d) { return "O crea una cuenta de " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1815222185 = messageFormatterFn((function(  ) {
  return function(d) { return "Evita usar espacios, tu nombre, tu correo o contraseñas que hayas usado antes."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b902679067 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocurrió un error. Espera unos minutos e inténtalo de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1395016949 = messageFormatterFn((function(  ) {
  return function(d) { return "Verifica tu celular"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1829289276 = messageFormatterFn((function(  ) {
  return function(d) { return "Te enviaremos un código de verificación por única vez a tu celular para asegurarnos de que tu cuenta siga siendo segura."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1075342805 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b598844036 = messageFormatterFn((function(  ) {
  return function(d) { return "© " + d["1"] + " " + d["0"] + " Todos los derechos reservados."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2078226230 = messageFormatterFn((function(  ) {
  return function(d) { return "Términos y condiciones"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a651371659 = messageFormatterFn((function(  ) {
  return function(d) { return "Aviso de privacidad"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a992051230 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar SMS"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1803218249 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa el código de verificación"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a44179177 = messageFormatterFn((function(  ) {
  return function(d) { return "Código de verificación"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1271521884 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar código"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1120315183 = messageFormatterFn((function(  ) {
  return function(d) { return "Cambiar número de celular"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a23604837 = messageFormatterFn((function(  ) {
  return function(d) { return "Te reenviamos el código de verificación."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b552979326 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa el código de verificación de 6 dígitos que acabamos de enviarte a " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1538894069 = messageFormatterFn((function(  ) {
  return function(d) { return "Verificando código de verificación"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2086767524 = messageFormatterFn((function(  ) {
  return function(d) { return "Este código es incorrecto. Reenvíate el código para intentarlo de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1198510230 = messageFormatterFn((function(  ) {
  return function(d) { return "o continúa con"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1954722438 = messageFormatterFn((function(  ) {
  return function(d) { return "Con tu membresía gratuita, obtén un promedio de " + d["0"] + "% de descuento en miles de hoteles."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a613741832 = messageFormatterFn((function(  ) {
  return function(d) { return "o"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1204304122 = messageFormatterFn((function(  ) {
  return function(d) { return "Otras opciones de inicio de sesión"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1203944708 = messageFormatterFn((function(  ) {
  return function(d) { return "Otras opciones de registro"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1791153486 = messageFormatterFn((function(  ) {
  return function(d) { return "Registrarme con Google"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a934077997 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicio de sesión incorrecto. Intenta de nuevo o crea una cuenta en este sitio para continuar."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b987526233 = messageFormatterFn((function(  ) {
  return function(d) { return "No se puede iniciar sesión con un número de teléfono. Asegúrate de que tu cuenta de red social esté asociada a una dirección de correo electrónico."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b328998241 = messageFormatterFn((function(  ) {
  return function(d) { return "Con tu membresía gratuita, obtén un " + d["0"] + "% o más de descuento en miles de hoteles."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b542592636 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sesión con Google"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a944486535 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sesión con NAVER"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1453756835 = messageFormatterFn((function(  ) {
  return function(d) { return "Excediste la cantidad de inicios de sesión máxima permitida. Vuelve a intentarlo más tarde."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b93154570 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión con tus datos biométricos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1579107178 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa tus datos biométricos para acceder a tu cuenta sin necesidad de ingresar tu contraseña."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1287083095 = messageFormatterFn((function(  ) {
  return function(d) { return "Comenzar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1696863609 = messageFormatterFn((function(  ) {
  return function(d) { return "Recordarme después"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1576939249 = messageFormatterFn((function(  ) {
  return function(d) { return "¡Listo!"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b213390743 = messageFormatterFn((function(  ) {
  return function(d) { return "Se activó el inicio de sesión con datos biométricos."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b52838191 = messageFormatterFn((function(  ) {
  return function(d) { return "Iniciar sesión con datos biométricos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b706694058 = messageFormatterFn((function(  ) {
  return function(d) { return "Usar contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b886004673 = messageFormatterFn((function(  ) {
  return function(d) { return "Usar datos biométricos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1333554008 = messageFormatterFn((function(  ) {
  return function(d) { return "Actualiza tu contraseña para continuar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1415740884 = messageFormatterFn((function(  ) {
  return function(d) { return "Debes restablecer la contraseña para poder acceder a tu cuenta."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a176479286 = messageFormatterFn((function(  ) {
  return function(d) { return "Restablecer contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1644771594 = messageFormatterFn((function(  ) {
  return function(d) { return "Ya puedes disfrutar de los beneficios para socios"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1228948656 = messageFormatterFn((function(  ) {
  return function(d) { return "¡Te regalamos $" + d["0"] + " en puntos para que comiences tu próxima aventura!"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b134063488 = messageFormatterFn((function(  ) {
  return function(d) { return "Ya están disponibles en tu cuenta para usarlos en tu primera reservación. Solo tienes que buscar la opción para aplicar tus puntos en la página de pago."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1556320558 = messageFormatterFn((function(  ) {
  return function(d) { return "Ya eres socio de Expedia."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1424530882 = messageFormatterFn((function(  ) {
  return function(d) { return "Comienza a ahorrar de inmediato con los Precios para socios y acumula puntos con cada reservación."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1545089207 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión o crea una cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1158481213 = messageFormatterFn((function(  ) {
  return function(d) { return "Los socios ahorran un promedio del " + d["0"] + "% en miles de hoteles de forma gratuita."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a143475743 = messageFormatterFn((function(  ) {
  return function(d) { return "Al continuar, declaras que leíste y aceptas nuestros <a href=" + d["1"] + " " + d["3"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["4"] + ">Aviso de privacidad</a>."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1696954019 = messageFormatterFn((function(  ) {
  return function(d) { return "Al continuar, declaras que leíste y aceptas nuestros <a href=" + d["1"] + " " + d["5"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["6"] + ">Aviso de privacidad</a>, así como los <a href=" + d["3"] + " " + d["7"] + ">Términos y condiciones de " + d["4"] + "</a>."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1050183042 = messageFormatterFn((function(  ) {
  return function(d) { return "Al continuar, declaras que leíste y aceptas nuestros <a href=" + d["1"] + " " + d["4"] + ">Términos y condiciones</a> y el <a href=" + d["2"] + " " + d["5"] + ">Aviso de privacidad</a>, así como los <a href=" + d["3"] + " " + d["6"] + ">Términos y condiciones del programa de lealtad One Key</a>."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1325854758 = messageFormatterFn((function(  ) {
  return function(d) { return "Correo electrónico"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a256836320 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa un correo electrónico válido"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1973417885 = messageFormatterFn((function(  ) {
  return function(d) { return "Google"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a163386864 = messageFormatterFn((function(  ) {
  return function(d) { return "Facebook"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1568378758 = messageFormatterFn((function(  ) {
  return function(d) { return "Apple"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a659513185 = messageFormatterFn((function(  ) {
  return function(d) { return "Elige esta opción únicamente para dispositivos personales. Por motivos de seguridad, no debes mantener la sesión abierta en dispositivos compartidos."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1035608432 = messageFormatterFn((function(  ) {
  return function(d) { return "Intentaste iniciar sesión demasiadas veces. Deberás esperar " + d["0"] + " minutos para volver a intentarlo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a439143284 = messageFormatterFn((function(  ) {
  return function(d) { return "Intentaste iniciar sesión demasiadas veces. Deberás esperar " + d["0"] + " minuto para volver a intentarlo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a444038618 = messageFormatterFn((function(  ) {
  return function(d) { return "Intentaste iniciar sesión demasiadas veces. Deberás esperar " + d["0"] + " minutos para volver a intentarlo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a430580774 = messageFormatterFn((function(  ) {
  return function(d) { return "Intentaste iniciar sesión demasiadas veces. Deberás esperar " + d["0"] + " minutos para volver a intentarlo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a659625831 = messageFormatterFn((function(  ) {
  return function(d) { return "Intentaste iniciar sesión demasiadas veces. Deberás esperar " + d["0"] + " minutos para volver a intentarlo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1286463710 = messageFormatterFn((function(  ) {
  return function(d) { return "Intentaste iniciar sesión demasiadas veces. Deberás esperar " + d["0"] + " minutos para volver a intentarlo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b800791731 = messageFormatterFn((function(  ) {
  return function(d) { return "Accede a un sinfín de recompensas con una sola cuenta en Expedia, Hoteles.com y Vrbo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2136186805 = messageFormatterFn((function(  ) {
  return function(d) { return "Accede a un sinfín de opciones de viaje con una sola cuenta en Expedia, Hoteles.com y Vrbo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a30610898 = messageFormatterFn((function(  ) {
  return function(d) { return "Consulta y guarda propiedades, ponte de acuerdo con tu grupo y accede a los detalles de tu reservación."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b168511791 = messageFormatterFn((function(  ) {
  return function(d) { return "Tu cuenta se puso en pausa debido a una verificación de seguridad de rutina. Tus datos están a salvo, aunque debes restablecer la contraseña."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a335459199 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión y reserva tu estadía para acumular OneKeyCash"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a628535733 = messageFormatterFn((function(  ) {
  return function(d) { return "Confirma tu cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1199042821 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa el código de seguridad que enviamos a tu correo electrónico. Si no aparece en tu bandeja de entrada, consulta tu correo no deseado."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a834568775 = messageFormatterFn((function(  ) {
  return function(d) { return "Confirma tu correo"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1621131059 = messageFormatterFn((function(  ) {
  return function(d) { return "Para continuar, ingresa el código de seguridad que enviamos a " + d["0"] + ". Si no aparece en tu bandeja de entrada, revisa el correo no deseado."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1157183987 = messageFormatterFn((function(  ) {
  return function(d) { return "Código de 6 dígitos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2139613171 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar código"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b857552886 = messageFormatterFn((function(  ) {
  return function(d) { return "(0:" + d["0"] + ")"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1093129742 = messageFormatterFn((function(  ) {
  return function(d) { return "Reenviar código en " + d["0"] + " s"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1722455774 = messageFormatterFn((function(  ) {
  return function(d) { return "¿No recibiste el correo?"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1735823164 = messageFormatterFn((function(  ) {
  return function(d) { return "Puedes solicitar otro código en 00:" + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1917207699 = messageFormatterFn((function(  ) {
  return function(d) { return "Solicitar otro código de seguridad"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b185641289 = messageFormatterFn((function(  ) {
  return function(d) { return "Te enviamos un código nuevo de 6 dígitos a tu correo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1061258562 = messageFormatterFn((function(  ) {
  return function(d) { return "Usar contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1097951041 = messageFormatterFn((function(  ) {
  return function(d) { return "Código no válido. Intenta de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2088517613 = messageFormatterFn((function(  ) {
  return function(d) { return "Código vencido. Reenvíalo y vuelve a intentar."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b971029918 = messageFormatterFn((function(  ) {
  return function(d) { return "Si no aparece en tu bandeja de entrada, consulta tu correo no deseado."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1229232969 = messageFormatterFn((function(  ) {
  return function(d) { return "Actualizamos la experiencia que te ofrecemos y necesitamos que confirmes tu correo electrónico. Ingresa el código de seguridad que enviamos a tu bandeja."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b250363114 = messageFormatterFn((function(  ) {
  return function(d) { return "Tuvimos una falla. Inténtalo de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b110509601 = messageFormatterFn((function(  ) {
  return function(d) { return "Para actualizar el método de inicio de sesión, ingresa el código de seguridad que enviamos a tu correo electrónico."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a939861063 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa tu contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1142008960 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar código de seguridad por correo"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2075866848 = messageFormatterFn((function(  ) {
  return function(d) { return "El correo electrónico y la contraseña no coinciden."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1254459305 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a575841370 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una contraseña | " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a577127251 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1302687065 = messageFormatterFn((function(  ) {
  return function(d) { return "Puedes usar el mismo correo electrónico y contraseña para iniciar sesión en Expedia, Hoteles.com y Vrbo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1157551385 = messageFormatterFn((function(  ) {
  return function(d) { return "Crear contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1771695780 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una contraseña para usarla junto con otras formas de inicio de sesión."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1635359527 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una contraseña nueva"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1012618966 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una nueva contraseña | " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1989897085 = messageFormatterFn((function(  ) {
  return function(d) { return "Crea una contraseña nueva"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a662991735 = messageFormatterFn((function(  ) {
  return function(d) { return "Ahora puedes usar una sola cuenta para iniciar sesión en Expedia, Hoteles.com y Vrbo. Crea una contraseña nueva y segura para tu cuenta de todos los sitios."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1184398775 = messageFormatterFn((function(  ) {
  return function(d) { return "Crear contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1073186047 = messageFormatterFn((function(  ) {
  return function(d) { return "Cambia la contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b627174076 = messageFormatterFn((function(  ) {
  return function(d) { return "Cambia la contraseña | " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1600161007 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa una contraseña única y segura."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b371123089 = messageFormatterFn((function(  ) {
  return function(d) { return "Actualizar contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b832536228 = messageFormatterFn((function(  ) {
  return function(d) { return "No fue posible cambiar la contraseña. Inténtalo de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b258588550 = messageFormatterFn((function(  ) {
  return function(d) { return "Olvidé la contraseña"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b186699744 = messageFormatterFn((function(  ) {
  return function(d) { return "Ingresa tu correo electrónico y te enviaremos un código de seguridad para que inicies sesión."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a193992960 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar correo"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1785662796 = messageFormatterFn((function(  ) {
  return function(d) { return "Contactarnos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a98974499 = messageFormatterFn((function(  ) {
  return function(d) { return "Borrar datos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a302007448 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerrar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1309628860 = messageFormatterFn((function(  ) {
  return function(d) { return "Espera mientras revisamos tu cuenta."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1660696067 = messageFormatterFn((function(  ) {
  return function(d) { return "Eliminación de la cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b784667289 = messageFormatterFn((function(  ) {
  return function(d) { return "Entendido"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1156015101 = messageFormatterFn((function(  ) {
  return function(d) { return "No podrás eliminar la cuenta hasta que se complete el viaje"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a264130398 = messageFormatterFn((function(  ) {
  return function(d) { return "Para tener un viaje sin complicaciones, necesitas tu cuenta a fin de acceder a tu reservación y obtener ayuda de nuestra atención a clientes por si hay cambios de última hora."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a938725365 = messageFormatterFn((function(  ) {
  return function(d) { return "Primero debes eliminar tu cuenta de propietario de Vrbo"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1921230430 = messageFormatterFn((function(  ) {
  return function(d) { return "Visita nuestro centro de ayuda en el sitio web o la aplicación para comunicarte directamente con atención a clientes e iniciar el proceso."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b262368046 = messageFormatterFn((function(  ) {
  return function(d) { return "Intenta de nuevo después de finalizar tu viaje."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a385617135 = messageFormatterFn((function(  ) {
  return function(d) { return "¿Por qué eliminas tu cuenta?"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1673278016 = messageFormatterFn((function(  ) {
  return function(d) { return "Recibo muchos correos o notificaciones"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a2054227286 = messageFormatterFn((function(  ) {
  return function(d) { return "Tengo otra cuenta de " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1327125487 = messageFormatterFn((function(  ) {
  return function(d) { return "Terminó mi viaje y ya no necesito la cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a461532951 = messageFormatterFn((function(  ) {
  return function(d) { return "Tuve una experiencia negativa al reservar con " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1421541016 = messageFormatterFn((function(  ) {
  return function(d) { return "Otro"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2008087979 = messageFormatterFn((function(  ) {
  return function(d) { return "Omitir"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a898433436 = messageFormatterFn((function(  ) {
  return function(d) { return "Enviar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1328689580 = messageFormatterFn((function(  ) {
  return function(d) { return "Respetamos tu decisión. Sin embargo, ten en cuenta lo siguiente:"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1664948383 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " puntos de Expedia Rewards con un valor de " + d["1"] + ", créditos con un valor de " + d["2"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1173914832 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " puntos de Expedia Rewards con un valor de " + d["1"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1750196942 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás tus listas de viajes, créditos y preferencias para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a904183144 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoteles.com Rewards: perderás " + d["0"] + " noche(s) de regalo con un valor de " + d["1"] + " y " + d["2"] + " sello(s) con un valor promedio de " + d["3"] + "."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1970825479 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás créditos, cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a719634081 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " CheapCash con un valor de " + d["1"] + ", créditos con un valor de " + d["2"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b611148816 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " CheapCash con un valor de " + d["1"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1924888231 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " Orbucks con un valor de " + d["1"] + ", créditos con un valor de " + d["2"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1275031096 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " Orbucks con un valor de " + d["1"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2106928863 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " MrJet Rewards con un valor de " + d["1"] + ", créditos con un valor de " + d["2"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a180353392 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " MrJet Rewards con un valor de " + d["1"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b224915391 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " BONUS+ con un valor de " + d["1"] + ", créditos con un valor de " + d["2"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1515849296 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás " + d["0"] + " BONUS+ con un valor de " + d["1"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1823207115 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1674540832 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás créditos con un valor de " + d["0"] + ", cupones, componentes de viajes guardados y preferencias de la cuenta para siempre."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1983330026 = messageFormatterFn((function(  ) {
  return function(d) { return "Es posible que guardemos información, como registros de tus transacciones, por motivos legales o en caso de que debamos establecer, ejercer o defender una acción legal. Esta información se almacenará de forma segura y se eliminará, se hará anónima o ilegible permanentemente cuando ya no sea necesario conservarla."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1178605718 = messageFormatterFn((function(  ) {
  return function(d) { return "Eliminar cuenta de forma permanente"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1466799706 = messageFormatterFn((function(  ) {
  return function(d) { return "No eliminar cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1349910576 = messageFormatterFn((function(  ) {
  return function(d) { return "Te extrañaremos"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1546207857 = messageFormatterFn((function(  ) {
  return function(d) { return "Es posible que nos lleve algunas semanas procesar tu solicitud de eliminación de datos, de modo que podrías seguir recibiendo comunicaciones mientras se actualiza nuestro sistema."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a61645003 = messageFormatterFn((function(  ) {
  return function(d) { return "Reintentar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1507028810 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocurrió un error en el sistema. Solicita de nuevo la eliminación de tu cuenta o vuelve a intentarlo en unos minutos."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1581565566 = messageFormatterFn((function(  ) {
  return function(d) { return "Cerrar"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a838055895 = messageFormatterFn((function(  ) {
  return function(d) { return "¿Qué nombre aparece en tu identificación para viajar?"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1114142823 = messageFormatterFn((function(  ) {
  return function(d) { return "Usa en tu cuenta el mismo nombre completo de tu identificación para viajar (p. ej., pasaporte) y lo tendremos listo para la próxima vez que reserves."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a466252935 = messageFormatterFn((function(  ) {
  return function(d) { return "Recibe correos electrónicos de " + d["0"] + " con ofertas y otra información."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1514340680 = messageFormatterFn((function(  ) {
  return function(d) { return "Recibe correos electrónicos de " + d["0"] + " con ofertas y otra información. Puedes desactivar los correos de marketing en cualquier momento."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b367524605 = messageFormatterFn((function(  ) {
  return function(d) { return "Información de la cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1913378112 = messageFormatterFn((function(  ) {
  return function(d) { return "Información de la cuenta | " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1124091801 = messageFormatterFn((function(  ) {
  return function(d) { return "Recibir correos electrónicos con descuentos, ofertas y más de " + d["0"] + ". Puedes darte de baja en cualquier momento."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2128180845 = messageFormatterFn((function(  ) {
  return function(d) { return "Cuenta | " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1409074357 = messageFormatterFn((function(  ) {
  return function(d) { return "Mantente al día"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1803431185 = messageFormatterFn((function(  ) {
  return function(d) { return "Consentimiento de marketing"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b604962784 = messageFormatterFn((function(  ) {
  return function(d) { return "Expedia Rewards"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1924351298 = messageFormatterFn((function(  ) {
  return function(d) { return "CheapCash"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b643769158 = messageFormatterFn((function(  ) {
  return function(d) { return "Orbitz Rewards"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1725100190 = messageFormatterFn((function(  ) {
  return function(d) { return "BONUS+"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b680129120 = messageFormatterFn((function(  ) {
  return function(d) { return "MrJet"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b2109665079 = messageFormatterFn((function(  ) {
  return function(d) { return "Hoteles.com Rewards"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b193745757 = messageFormatterFn((function(  ) {
  return function(d) { return "One Key"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1682802768 = messageFormatterFn((function(  ) {
  return function(d) { return "Debes esperar a que hayas completado el viaje"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1568252800 = messageFormatterFn((function(  ) {
  return function(d) { return "Debes esperar a que hayas completado los viajes"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b48985158 = messageFormatterFn((function(  ) {
  return function(d) { return "Si necesitas, puedes acceder a los detalles de tu reservación y solicitar ayuda desde tu cuenta. Intenta de nuevo después de finalizar tu viaje."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1872161814 = messageFormatterFn((function(  ) {
  return function(d) { return "Si necesitas, puedes acceder a los detalles de tu reservación y solicitar ayuda desde tu cuenta. Intenta de nuevo después de finalizar tus viajes."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1578488419 = messageFormatterFn((function(  ) {
  return function(d) { return "No es posible eliminar tu cuenta en este momento"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a968109005 = messageFormatterFn((function(  ) {
  return function(d) { return "Esta cuenta también se usa para anunciar propiedades en Vrbo. Antes de eliminarla, debes iniciar sesión en el sitio web o la app para propietarios de Vrbo y borrar los anuncios activos."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1877488578 = messageFormatterFn((function(  ) {
  return function(d) { return "¿Por qué quieres eliminar tu cuenta?"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1100676375 = messageFormatterFn((function(  ) {
  return function(d) { return "Tengo una cuenta con otro correo electrónico"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b560572438 = messageFormatterFn((function(  ) {
  return function(d) { return "Tuve una experiencia negativa con una reservación"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1779624257 = messageFormatterFn((function(  ) {
  return function(d) { return "Respetamos tu decisión. Ten en cuenta que la eliminación de la cuenta no se puede revertir y se verán afectados tus datos de Expedia, Hoteles.com y Vrbo. También toma en cuenta lo siguiente:"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b218579894 = messageFormatterFn((function(  ) {
  return function(d) { return "Respetamos tu decisión. Ten en cuenta que la eliminación de la cuenta no se puede revertir y se verán afectados tus datos de Expedia, Wotif, Hoteles.com y Vrbo. También toma en cuenta lo siguiente:"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1636227357 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás el historial de tu cuenta, así como las preferencias y los elementos guardados en Expedia, Hoteles.com y Vrbo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b851263448 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás el historial de tu cuenta, así como las preferencias y los elementos guardados en Expedia, Wotif, Hoteles.com y Vrbo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a919102609 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás tu crédito OneKeyCash, incluido el que tengas pendiente, así como tu nivel de One Key y todas sus ventajas."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1539124487 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás tu crédito OneKeyCash pendiente, así como tu nivel de One Key y todas sus ventajas."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b949777468 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás tu monto de " + d["0"] + " en crédito OneKeyCash y el crédito OneKeyCash que tengas pendiente, así como tu nivel de One Key y todas sus ventajas."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a576927378 = messageFormatterFn((function(  ) {
  return function(d) { return "Los titulares de la tarjeta de crédito de Hoteles.com Rewards dejarán de recibir recompensas por su actividad con la tarjeta."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b493956881 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás todos los puntos de Expedia Rewards, incluidos los puntos confirmados y pendientes, así como los sellos y las noches de regalo de Hoteles.com Rewards, y tu nivel en los programas de lealtad."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1985900133 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás todos los puntos pendientes de Expedia Rewards, así como los sellos y las noches de regalo de Hoteles.com Rewards, y tu nivel en los programas de lealtad."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1739387371 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás todos los cupones y créditos de Expedia, Hoteles.com y Vrbo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1169852022 = messageFormatterFn((function(  ) {
  return function(d) { return "Perderás todos los cupones y créditos de Expedia, Wotif, Hoteles.com y Vrbo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b427573308 = messageFormatterFn((function(  ) {
  return function(d) { return "La solicitud de eliminación de Expedia, Hoteles.com y Vrbo puede tardar unas semanas en procesarse, por lo que es posible que sigas recibiendo mensajes mientras actualizamos nuestro sistema."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a11259279 = messageFormatterFn((function(  ) {
  return function(d) { return "La solicitud de eliminación de Expedia, Wotif, Hoteles.com y Vrbo puede tardar unas semanas en procesarse, por lo que es posible que sigas recibiendo mensajes mientras actualizamos nuestro sistema."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a39185593 = messageFormatterFn((function(  ) {
  return function(d) { return "Tu Tarjeta One Key se cancelará si eliminas tu cuenta y ya no podrás acumular OneKeyCash por ninguna compra. Wells Fargo te contactará para confirmar la cancelación de la tarjeta."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b252728559 = messageFormatterFn((function(  ) {
  return function(d) { return "Tu Tarjeta One Key+ se cancelará si eliminas tu cuenta y ya no podrás acumular OneKeyCash por ninguna compra. Wells Fargo te contactará para confirmar la cancelación de la tarjeta."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1401840826 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión o crea una cuenta para acumular crédito OneKeyCash por tu viaje"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a42955872 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicia sesión o crea una cuenta para obtener recompensas por esta estadía"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1764092231 = messageFormatterFn((function(  ) {
  return function(d) { return "Reservar sin iniciar sesión"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1177501963 = messageFormatterFn((function(  ) {
  return function(d) { return "Inicio de sesión en " + d["0"] + ": agrega un celular"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b944392805 = messageFormatterFn((function(  ) {
  return function(d) { return "Ocurrió un error"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b698330933 = messageFormatterFn((function(  ) {
  return function(d) { return "Intenta iniciar sesión de nuevo."; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.a1750557890 = messageFormatterFn((function(  ) {
  return function(d) { return "Entendido"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1556878025 = messageFormatterFn((function(  ) {
  return function(d) { return "Logo de " + d["0"]; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b1652909110 = messageFormatterFn((function(  ) {
  return function(d) { return "Cuenta"; }
})(), Globalize("es-CO").pluralGenerator({}));
Globalize.b634485322 = dateToPartsFormatterFn({"2":Globalize("es-CO").numberFormatter({"raw":"00"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.b1749031690 = dateToPartsFormatterFn({"2":Globalize("es-CO").numberFormatter({"raw":"00"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.a600282825 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b522171133 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.b1694890666 = dateToPartsFormatterFn({"2":Globalize("es-CO").numberFormatter({"raw":"00"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b946014005 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.a102831350 = dateToPartsFormatterFn({"2":Globalize("es-CO").numberFormatter({"raw":"00"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.b1640749642 = dateToPartsFormatterFn({"2":Globalize("es-CO").numberFormatter({"raw":"00"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b1111255370 = dateToPartsFormatterFn({"2":Globalize("es-CO").numberFormatter({"raw":"00"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.a358711433 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a1881656662 = dateToPartsFormatterFn({"2":Globalize("es-CO").numberFormatter({"raw":"00"}),"4":Globalize("es-CO").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b83463959 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"D","mon":"L","tue":"M","wed":"M","thu":"J","fri":"V","sat":"S"}}}});
Globalize.a828560758 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"domingo","mon":"lunes","tue":"martes","wed":"miércoles","thu":"jueves","fri":"viernes","sat":"sábado"}}}});
Globalize.b424684682 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"enero","2":"febrero","3":"marzo","4":"abril","5":"mayo","6":"junio","7":"julio","8":"agosto","9":"septiembre","10":"octubre","11":"noviembre","12":"diciembre"}}}});
Globalize.b53144278 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.a1609226601 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"}),"2":Globalize("es-CO").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a1355528376 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"d 'de' MMM","timeSeparator":":","months":{"M":{"3":{"1":"ene.","2":"feb.","3":"mar.","4":"abr.","5":"may.","6":"jun.","7":"jul.","8":"ago.","9":"sep.","10":"oct.","11":"nov.","12":"dic."}}}});
Globalize.b947654447 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"d 'de' MMMM","timeSeparator":":","months":{"M":{"4":{"1":"enero","2":"febrero","3":"marzo","4":"abril","5":"mayo","6":"junio","7":"julio","8":"agosto","9":"septiembre","10":"octubre","11":"noviembre","12":"diciembre"}}}});
Globalize.b1550462972 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"d 'de' MMMM 'de' y","timeSeparator":":","months":{"M":{"4":{"1":"enero","2":"febrero","3":"marzo","4":"abril","5":"mayo","6":"junio","7":"julio","8":"agosto","9":"septiembre","10":"octubre","11":"noviembre","12":"diciembre"}}}});
Globalize.b1574096228 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"MMMM 'de' y","timeSeparator":":","months":{"M":{"4":{"1":"enero","2":"febrero","3":"marzo","4":"abril","5":"mayo","6":"junio","7":"julio","8":"agosto","9":"septiembre","10":"octubre","11":"noviembre","12":"diciembre"}}}});
Globalize.b1573411035 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"d 'de' MMM 'de' y","timeSeparator":":","months":{"M":{"3":{"1":"ene.","2":"feb.","3":"mar.","4":"abr.","5":"may.","6":"jun.","7":"jul.","8":"ago.","9":"sep.","10":"oct.","11":"nov.","12":"dic."}}}});
Globalize.a1691530488 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d 'de' MMM","timeSeparator":":","days":{"E":{"4":{"sun":"domingo","mon":"lunes","tue":"martes","wed":"miércoles","thu":"jueves","fri":"viernes","sat":"sábado"}}},"months":{"M":{"3":{"1":"ene.","2":"feb.","3":"mar.","4":"abr.","5":"may.","6":"jun.","7":"jul.","8":"ago.","9":"sep.","10":"oct.","11":"nov.","12":"dic."}}}});
Globalize.b955042615 = dateToPartsFormatterFn({"1":Globalize("es-CO").numberFormatter({"raw":"0"})}, {"pattern":"E, d 'de' MMM","timeSeparator":":","days":{"E":{"1":{"sun":"dom.","mon":"lun.","tue":"mar.","wed":"mié.","thu":"jue.","fri":"vie.","sat":"sáb."}}},"months":{"M":{"3":{"1":"ene.","2":"feb.","3":"mar.","4":"abr.","5":"may.","6":"jun.","7":"jul.","8":"ago.","9":"sep.","10":"oct.","11":"nov.","12":"dic."}}}});
Globalize.b255771571 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.b1370317939 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.b1879767264 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a1292746074 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.b1316176915 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.a868903202 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.a481545101 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.b1262035891 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b732541619 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.b2121338656 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.b2034596883 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b234637326 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b7599795 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b1260845235 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a530139315 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"d"}));
Globalize.a1217819520 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a1783386945 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b568940696 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.a1599728717 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.b1195382477 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.b1194697284 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a1073799937 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b576328864 = dateFormatterFn(Globalize("es-CO").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a1358290172 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.a243743804 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a1625819023 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.a503365065 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.a297884828 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.a79522193 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a2095606844 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.a352025852 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.a881520124 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a1384247631 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b420535140 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1571497443 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^D/],["mon",/^L/],["tue",/^M/],["wed",/^M/],["thu",/^J/],["fri",/^V/],["sat",/^S/]]});
Globalize.b919168708 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^miércoles/],["sun",/^domingo/],["fri",/^viernes/],["tue",/^martes/],["thu",/^jueves/],["sat",/^sábado/],["mon",/^lunes/]]});
Globalize.a2122553148 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septiembre/],["11",/^noviembre/],["12",/^diciembre/],["2",/^febrero/],["10",/^octubre/],["8",/^agosto/],["1",/^enero/],["3",/^marzo/],["4",/^abril/],["6",/^junio/],["7",/^julio/],["5",/^mayo/]]});
Globalize.b1027647708 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d","digitsRe":/\d/});
Globalize.a1373422511 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b1212587854 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d 'de' MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^ene\./],["2",/^feb\./],["3",/^mar\./],["4",/^abr\./],["5",/^may\./],["6",/^jun\./],["7",/^jul\./],["8",/^ago\./],["9",/^sep\./],["10",/^oct\./],["11",/^nov\./],["12",/^dic\./]]});
Globalize.a1045121047 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d 'de' MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septiembre/],["11",/^noviembre/],["12",/^diciembre/],["2",/^febrero/],["10",/^octubre/],["8",/^agosto/],["1",/^enero/],["3",/^marzo/],["4",/^abril/],["6",/^junio/],["7",/^julio/],["5",/^mayo/]]});
Globalize.a96035198 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d 'de' MMMM 'de' y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septiembre/],["11",/^noviembre/],["12",/^diciembre/],["2",/^febrero/],["10",/^octubre/],["8",/^agosto/],["1",/^enero/],["3",/^marzo/],["4",/^abril/],["6",/^junio/],["7",/^julio/],["5",/^mayo/]]});
Globalize.a418679266 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"MMMM 'de' y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^septiembre/],["11",/^noviembre/],["12",/^diciembre/],["2",/^febrero/],["10",/^octubre/],["8",/^agosto/],["1",/^enero/],["3",/^marzo/],["4",/^abril/],["6",/^junio/],["7",/^julio/],["5",/^mayo/]]});
Globalize.a419364459 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"d 'de' MMM 'de' y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["1",/^ene\./],["2",/^feb\./],["3",/^mar\./],["4",/^abr\./],["5",/^may\./],["6",/^jun\./],["7",/^jul\./],["8",/^ago\./],["9",/^sep\./],["10",/^oct\./],["11",/^nov\./],["12",/^dic\./]]});
Globalize.b866660366 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"EEEE, d 'de' MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["wed",/^miércoles/],["sun",/^domingo/],["fri",/^viernes/],["tue",/^martes/],["thu",/^jueves/],["sat",/^sábado/],["mon",/^lunes/]],"gregorian/months/format/abbreviated":[["1",/^ene\./],["2",/^feb\./],["3",/^mar\./],["4",/^abr\./],["5",/^may\./],["6",/^jun\./],["7",/^jul\./],["8",/^ago\./],["9",/^sep\./],["10",/^oct\./],["11",/^nov\./],["12",/^dic\./]]});
Globalize.a1037732879 = dateParserFn(Globalize("es-CO").numberParser({"raw":"0"}), {"preferredTimeData":"h"}, {"pattern":"E, d 'de' MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^dom\./],["mon",/^lun\./],["tue",/^mar\./],["wed",/^mié\./],["thu",/^jue\./],["fri",/^vie\./],["sat",/^sáb\./]],"gregorian/months/format/abbreviated":[["1",/^ene\./],["2",/^feb\./],["3",/^mar\./],["4",/^abr\./],["5",/^may\./],["6",/^jun\./],["7",/^jul\./],["8",/^ago\./],["9",/^sep\./],["10",/^oct\./],["11",/^nov\./],["12",/^dic\./]]});
module.exports = Globalize;
